import { useEffect, useState } from "react";
import RouteManager from "../../../managers/RouteManager";
import { DKLabel, DKButton, DKExpandableWrapper, DKLine, DKInput, INPUT_VIEW_DIRECTION, showToast, showLoader, TOAST_TYPE, removeLoader } from "deskera-ui-library";
import { CONSTANTS, ERF, INPUT_TYPE } from "../../../constants/Constant";
import { EMPLOYEE_FIELD, PREVIOUS_EMPLOYER_SECTION, OPTIONAL_SECTION, MEDICAL_EXPENSES } from "./MYConstants";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployee, selectEmployee } from "../../../Redux/Slices/EmployeeListSlice";
import Utility, { deepClone, removeDelayedLoader, showDelayedLoader } from "../../../utility/Utility";
import EmployeeListService from "../../../services/EmployeeListService";
import TaxService from "../../../services/compliance/TaxSerivce";
import { getIRASReportYears, scrollToError } from "../../../managers/common/CommonUtil";
import { COUNTRY } from "../../../constants/CountryConstant";
import PermissionUtils, { ACTION, MODULE } from "../../user-permissions/PermissionUtils";

const UserTaxDetails = (props) => {

    const [optionalDeductionFields, setOptionalDeductionFields] = useState(OPTIONAL_SECTION);
    const [previousEmployerFields, setPrevioudEmployerFields] = useState(PREVIOUS_EMPLOYER_SECTION);
    const [employeeFields, setEmployeeFields] = useState(EMPLOYEE_FIELD);
    const [formValues, setFormValues] = useState({});
    const [expandedState, setExpandedState] = useState(true);
    const [userList, setUserList] = useState([]);
    const [medicalExpensesFields, setMedicalExpensesFields] = useState(MEDICAL_EXPENSES);
    const [formYears, setFormYears] = useState(getIRASReportYears());

    const dispatch = useDispatch();
    const employeeData = useSelector(selectEmployee);

    useEffect(() => {
        RouteManager.setPresenter({ props: props });
        loadEmployee({
            Limit: 10000,
            currentPage: '1',
            sort: '',
            order: 'desc',
            field: `_id`,
            searchField: ``,
            searchString: ``,
            isInCompleteProfile: false
        });
        setDefaultValues();
    }, [])

    useEffect(() => {
        if (!Utility.isEmpty(employeeData)) {
            const { users } = employeeData;
            const userList = users.map((u) => {
                return {
                    id: u.userId,
                    name: `${u.firstname} ${u.lastName}`,
                    ...u
                }
            })
            const alteredField = [{ columnCode: "employee", options: userList },{columnCode: "year", options: formYears}];
            const employeeFieldsCopy = deepClone(employeeFields);
            EmployeeListService.getAlteredConfigDetails(employeeFieldsCopy, alteredField, false, {}, {});
            setEmployeeFields(employeeFieldsCopy);
        }

    }, [employeeData]);

    const setDefaultValues = () => {
        const formFields = optionalDeductionFields.concat(previousEmployerFields,medicalExpensesFields);
        const values = deepClone(formValues);
        formFields.forEach((f) => {
            switch (f.type) {
                case INPUT_TYPE.NUMBER:
                    values[f.columnCode] = 0;
                    break;
                case INPUT_TYPE.TEXT:
                    values[f.columnCode] = CONSTANTS.EMPTY_STRING;
                    break;
                case INPUT_TYPE.DROPDOWN:
                    values[f.columnCode] = {};
                    break;
                default:
                    values[f.columnCode] = CONSTANTS.EMPTY_STRING;
            }
        });
        setFormValues(values);
        return values;
    }

    const getFormValues = () => {
        const formFields = optionalDeductionFields.concat(previousEmployerFields, employeeFields);
        formFields.forEach((f) => {
            switch (f.type) {
                case INPUT_TYPE.NUMBER:
                    formValues[f.columnCode] = formValues[f.columnCode] ? parseInt(formValues[f.columnCode]) : 0;
                    break;
                case INPUT_TYPE.TEXT:
                    formValues[f.columnCode] = formValues[f.columnCode] ? formValues[f.columnCode] : CONSTANTS.EMPTY_STRING;
                    break;
                case INPUT_TYPE.DROPDOWN:
                    formValues[f.columnCode] = formValues[f.columnCode] ? formValues[f.columnCode] : {};
                    break;
                default:
                    formValues[f.columnCode] = CONSTANTS.EMPTY_STRING;
            }
        });
        setFormValues(formValues);
        return formValues;
    }

    const loadEmployee = async (config) => {
        try {
            EmployeeListService.apiConfig = config;
            const timeout = showDelayedLoader();
            await dispatch(fetchEmployee());
            removeDelayedLoader(timeout);
        } catch (err) {
            showToast("Something went wrong", TOAST_TYPE.ERROR);
        }
    }

    const navigateTo = () => {
        RouteManager.navigateToHome();
    }

    const getRequiredFields = (o) => {
        let isRequired = false;
        isRequired = o?.validation?.some(v => v["required"]);
        return isRequired ? true : false;
    }

    const onInputChange = (v, o, i) => {
        const employeeFieldsCopy = deepClone(employeeFields);
        const optionalDeductionCopy = deepClone(optionalDeductionFields);
        const previousSectionCopy = deepClone(previousEmployerFields);
        const medicalSectionCopy = deepClone(medicalExpensesFields);
        let alteredConfig = [];
        if (o.columnCode === "employee") {
            formValues[o.columnCode] = v;
            let { isValid, errMsg } = checkFieldValidation(o);
            alteredConfig.push({ columnCode: o.columnCode, hasError: !isValid, errMsg: errMsg });
            EmployeeListService.getAlteredConfigDetails(employeeFieldsCopy, alteredConfig, false, {}, {});
            setEmployeeFields(employeeFieldsCopy);
            fetchUserTaxDetails();
        } else if(o.columnCode === "year") {
            if(!Utility.isEmptyObject(formValues[o.columnCode])) {
                const previousValue = EmployeeListService.getSelectedIdFromObject(formValues[o.columnCode], "id");
                const currentValue = EmployeeListService.getSelectedIdFromObject(v, "id");
                if(parseInt(previousValue) != parseInt(currentValue)) {
                    formValues["id"] = CONSTANTS.EMPTY_STRING;
                }
            }
            formValues[o.columnCode] = v;
            let { isValid, errMsg } = checkFieldValidation(o);
            alteredConfig.push({ columnCode: o.columnCode, hasError: !isValid, errMsg: errMsg });
            EmployeeListService.getAlteredConfigDetails(employeeFieldsCopy, alteredConfig, false, {}, {});
            const configFields = getConditonalFieldConfig(o,v);
            EmployeeListService.getAlteredConfigDetails(optionalDeductionCopy, configFields, false, {}, {});
            setEmployeeFields(employeeFieldsCopy);
            setOptionalDeductionFields(optionalDeductionCopy);
            fetchUserTaxDetails();
        } else {
            if (Utility.isEmptyObject(formValues["employee"])) {
                checkIfValidEmployee();
            } else {
                formValues[o.columnCode] = v;
                let { isValid, errMsg } = checkFieldValidation(o);
                if(isValid && !Utility.isEmpty(o.dependentField)) {
                    let { isValidField, fieldErrMsg } = checkDependentFieldCondition(isValid, errMsg, o, i);
                    alteredConfig.push({ columnCode: o.columnCode, hasError: !isValidField, errMsg: fieldErrMsg });
                    if(isValidField) {
                        const alteredFields = checkDependentFieldsValidation(optionalDeductionCopy,medicalSectionCopy, o);
                        alteredConfig = alteredConfig.concat(alteredFields);
                    }
                } else {
                    alteredConfig.push({ columnCode: o.columnCode, hasError: !isValid, errMsg: errMsg });
                }
                EmployeeListService.getAlteredConfigDetails(optionalDeductionCopy, alteredConfig, false, {}, {});
                EmployeeListService.getAlteredConfigDetails(previousSectionCopy, alteredConfig, false, {}, {});
                EmployeeListService.getAlteredConfigDetails(medicalSectionCopy, alteredConfig, false, {}, {});
                setOptionalDeductionFields(optionalDeductionCopy);
                setPrevioudEmployerFields(previousSectionCopy);
                setMedicalExpensesFields(medicalSectionCopy);
            }
        }
    }

    const getConditonalFieldConfig = (o, v) => {
        const fields = [];
        if(!Utility.isEmptyObject(o.conditionalHideShowFields)) {
            o.conditionalHideShowFields.forEach((c) => {
                switch(c?.groupName) {
                    case "visibility":
                        let value = c.value;
                        c.condition.forEach((con) => {
                            switch(con["key"]) {
                                case "greaterThan":
                                    const selectedValue = EmployeeListService.getSelectedIdFromObject(v, "id");
                                    if(parseInt(selectedValue) >  con["value"]) {
                                        value = c.value;
                                    } else {
                                        value = !c.value;
                                    }
                            }
                        })
                        c.fields.forEach((f) => {
                            let group = {
                                columnCode : f,
                                uiVisible : value
                            }
                            if(!value) {
                                formValues[f] = 0;   
                            }
                            fields.push(group);
                        })
                        break;
                }
            })
        }
        return fields;
    }

    const checkIfValidEmployee = () => {
        const employeeFieldsCopy = deepClone(employeeFields);
        const field = employeeFieldsCopy[0];
        let { isValid, errMsg } = checkFieldValidation(field);
        const alteredConfig = [];
        alteredConfig.push({ columnCode: field.columnCode, hasError: !isValid, errMsg: errMsg });
        EmployeeListService.getAlteredConfigDetails(employeeFieldsCopy, alteredConfig, false, {}, {});
        setEmployeeFields(employeeFieldsCopy);
        setTimeout(() => {
            scrollToError(field?.columnCode);
        }, 100)

    }

    const checkDependentFieldsValidation = (optionalDeductionCopy,medicalSectionCopy, o) => {
        const alteredConfig = [];
        o.dependentField.forEach((d) => {
            let fieldObject = {};
            let index = optionalDeductionCopy.findIndex((f) => f.columnCode === d.fieldId);
            if(index != -1) {
                fieldObject = optionalDeductionCopy[index];
            }
            index = medicalSectionCopy.findIndex((f) => f.columnCode === d.fieldId);
            if(index != -1) {
                fieldObject = medicalSectionCopy[index];
            }
            if(!Utility.isEmpty(fieldObject)) {
                let { isValid, errMsg } = checkFieldValidation(fieldObject);
                if(isValid) {
                    let { isValidField, fieldErrMsg } = checkDependentFieldCondition(isValid, errMsg, fieldObject, index);
                    alteredConfig.push({ columnCode: fieldObject.columnCode, hasError: !isValidField, errMsg: fieldErrMsg });
                }
            }
        });
        return alteredConfig;
    }

    const checkDependentFieldCondition = (isValidField, fieldErrMsg, o, i) => {
        let fieldsAddition = parseInt(formValues[o.columnCode]);
        const fields = [i];
        let limit = 0;
        for(let d = 0; d < o.dependentField.length; d++) {
            const dependentObject = o.dependentField[d];
            const condition = dependentObject.conditon;
            const dependentFieldValue = formValues[dependentObject?.fieldId];
            fields.push(parseInt(dependentObject?.name))
            if(!Utility.isEmptyObject(dependentFieldValue)) {
                for(const c in condition) {
                    switch(condition[c]) {
                        case "add":
                            limit = condition["limit"];
                            fieldsAddition += parseInt(dependentFieldValue);
                            if(fieldsAddition >  limit) {
                                isValidField = false;
                            }
                            break;
                    }
                }
            }   
        }
        if(!isValidField) {
            fieldErrMsg = `Addition of fields ${fields.sort().map(res=> res).join(', ')} should not exceed ${limit}`
        }
        return {isValidField, fieldErrMsg};
    }

    const fetchUserTaxDetails = () => {
        const userId = EmployeeListService.getSelectedIdFromObject(formValues["employee"], "id");
        const year = EmployeeListService.getSelectedIdFromObject(formValues["year"], "id");
        if(Utility.isEmpty(userId) || Utility.isEmpty(year)) {
            return;
        }
        const params = {
            userIds: [userId],
            year: year
        }
        showLoader("Fetching user tax details... Please wait");
        TaxService.fetchUserTaxDetails(params).then((response) => {
            if (response) {
                const userDetails = response?.myUserTaxDetails[0];
                updateUserFormValues(userDetails);
            }
            removeLoader();
        }, (error) => {
            setDefaultValues();
            removeLoader();
        })
    }

    const updateUserFormValues = (userDetails) => {
        const values = deepClone(formValues);
        for (const k in userDetails) {
            if(k != "year") {
                values[k] = userDetails[k];
            }
        }
        setFormValues(values);
    }

    const isInvalid = () => {
        let invalid = false;
        const alteredConfig = [];
        const invalidFields = [];
        const employeeFieldsCopy = deepClone(employeeFields);
        const optionalDeductionCopy = deepClone(optionalDeductionFields);
        const medicalSectionCopy = deepClone(medicalExpensesFields);
        const fields = employeeFieldsCopy.concat(optionalDeductionCopy,medicalSectionCopy);
        fields.forEach((f, i) => {
            if (f.columnCode === "employee" || f.columnCode === "year") {
                let { isValid, errMsg } = checkFieldValidation(f);
                if (!isValid) {
                    invalid = !isValid;
                    alteredConfig.push({ columnCode: f.columnCode, hasError: !isValid, errMsg: errMsg });
                    EmployeeListService.getAlteredConfigDetails(employeeFieldsCopy, alteredConfig, false, {}, {});
                    if(invalid) invalidFields.push(f.columnCode);
                    setEmployeeFields(employeeFieldsCopy);
                }
            } else {
                let { isValid, errMsg } = checkFieldValidation(f);
                if(isValid && !Utility.isEmpty(f.dependentField)) {
                    let index = calculateFieldIndex(optionalDeductionCopy, medicalSectionCopy, f);
                    let { isValidField, fieldErrMsg } = checkDependentFieldCondition(isValid, errMsg, f, index+1);
                    alteredConfig.push({ columnCode: f.columnCode, hasError: !isValidField, errMsg: fieldErrMsg });
                    invalid = !isValidField;
                    if(invalid) invalidFields.push(f.columnCode);
                } else {
                    invalid = !isValid;
                    alteredConfig.push({ columnCode: f.columnCode, hasError: !isValid, errMsg: errMsg });
                    if(invalid) invalidFields.push(f.columnCode);
                }
                EmployeeListService.getAlteredConfigDetails(optionalDeductionCopy, alteredConfig, false, {}, {});
                EmployeeListService.getAlteredConfigDetails(medicalSectionCopy, alteredConfig, false, {}, {});
                setOptionalDeductionFields(optionalDeductionCopy);
                setMedicalExpensesFields(medicalSectionCopy);
            }
        });
        if (!Utility.isEmpty(invalidFields.length)) {
            setTimeout(() => {
                scrollToError(invalidFields[0]);
            }, 100)
        }

        return invalidFields.length > 0;
    }

    const calculateFieldIndex = (optionalDeductionCopy, medicalSectionCopy, o) => {
        let index = 0;
        let fieldIndex = optionalDeductionCopy.findIndex((f) => f.columnCode === o.columnCode);
        if(fieldIndex != -1) {
            index = fieldIndex;
        }
        fieldIndex = medicalSectionCopy.findIndex((f) => f.columnCode === o.columnCode);
        if(fieldIndex != -1) {
            index = fieldIndex;
        }
        return index;
    }

    const checkFieldValidation = (f) => {
        let isValid = true;
        let errMsg = CONSTANTS.EMPTY_STRING;
        f?.validation?.forEach((v) => {
            for (const k in v) {
                switch (k) {
                    case "required":
                        if (v[k] && Utility.isEmptyObject(formValues[f.columnCode])) {
                            isValid = false;
                            errMsg = `Select a valid ${f.name}`
                        }
                        break;
                    case "max":
                        if (!Utility.isEmptyObject(formValues["employee"])) {
                            if (typeof formValues[f.columnCode] === "string" && parseInt(formValues[f.columnCode]) > v[k]) {
                                isValid = false;
                                errMsg = `Amount should not exceed ${v[k]}.`
                            }
                            if (typeof formValues[f.columnCode] === "number" && formValues[f.columnCode] > parseFloat(v[k])) {
                                isValid = false;
                                errMsg = `Amount should not exceed ${v[k]}.`
                            }
                        }
                        break;
                }
            }
        })
        return { isValid, errMsg }
    }

    const saveTaxDetails = () => {
        if (isInvalid()) {
            return;
        }
        const params = deepClone(getFormValues());
        const recordId = params["id"];
        params["userId"] = EmployeeListService.getSelectedIdFromObject(formValues["employee"], "id");
        params["year"] = EmployeeListService.getSelectedIdFromObject(formValues["year"], "id");
        params["employee"] = CONSTANTS.EMPTY_STRING;
        params["countryCode"] = COUNTRY.MY;
        if (Utility.isEmpty(recordId)) {
            addUserTaxDetails(params);
        } else {
            updateUserTaxDetails(params);
        }
    }

    const addUserTaxDetails = (params) => {
        showLoader("Adding user tax details.. Please wait");
        TaxService.postUserTaxDetails(params).then((response) => {
            if (response) {
                if(response?.isSocsoLimitExceeded) {
                    updateEmployeeSocsoField(response);
                } else {
                    showToast("User tax details added succesfully", TOAST_TYPE.SUCCESS);
                    navigateTo();
                }
            }
            removeLoader();
        }, (error) => {
            const errMsg = error?.message || "Something went wrong";
            showToast(errMsg, TOAST_TYPE.ERROR);
            removeLoader();
        });
    }

    const updateUserTaxDetails = (params) => {
        showLoader("Updating user tax details.. Please wait");
        TaxService.updatetUserTaxDetails(params).then((response) => {
            if (response) {
                if(response?.isSocsoLimitExceeded) {
                    updateEmployeeSocsoField(response);
                } else {
                    showToast("User tax details added succesfully", TOAST_TYPE.SUCCESS);
                    navigateTo();
                }
            }
            removeLoader();
        }, (error) => {
            const errMsg = error?.message || "Something went wrong";
            showToast(errMsg, TOAST_TYPE.ERROR);
            removeLoader();
        });
    }

    const updateEmployeeSocsoField = (response) => {
        showToast(`Employee socso amount exceeds yearly contribution of RM350`, TOAST_TYPE.FAILURE);
        const previousSectionCopy = deepClone( previousEmployerFields);
        const alteredConfig = [{columnCode:"employeeSocso",validation:[{"max":`${response?.availableEmployeeSocsoLimit}`}], hasError: true, errMsg: `Amount greater than ${response?.availableEmployeeSocsoLimit} exceeds yearly contribution limit of RM350` }];
        EmployeeListService.getAlteredConfigDetails(previousSectionCopy, alteredConfig, false, {}, {});
        setPrevioudEmployerFields(previousSectionCopy);        
    }

    const getPreviousSectionFormFields = (formFields) => {
        return formFields.map((o, i) => {
            return (
                <>
                    {(o.type === INPUT_TYPE.TEXT || o.type === INPUT_TYPE.NUMBER) && o.uiVisible && (
                        <div className={`column p-h-l mb-l web-width-50 padding-bottom-mobile ${o.columnCode}`}
                            key={o.columnCode}>
                            <DKInput
                                ref={ERF.ADD_EMPLOYEE[o.columnCode]}
                                title={`${i+1}. ${o.name}`}
                                placeholder={o.name}
                                value={formValues[o.columnCode]}
                                options={o.options}
                                type={o.type}
                                labelClassName=" text-align-left "
                                onChange={(v) => {
                                    onInputChange(v, o, i+1);
                                }}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                required={getRequiredFields(o)}
                                readOnly={o.readOnly || !PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT])}
                                tooltip={{
                                    content: o.tooltipText,
                                    className: "warning-tooltip-prop",
                                }}
                            />
                            {o.hasError && <DKLabel
                                className="mt-s pl-s unselectable text-red"
                                style={{
                                    whiteSpace: "nowrap",
                                    fontSize: "11px"
                                }}
                                text={o.errMsg}
                            />}
                        </div>
                        
                    )}
                </>
            )
        })
    }

    const getFormFields = (formFields) => {
        return formFields.map((o, i) => {
            return (
                <>
                    {(o.type === INPUT_TYPE.TEXT || o.type === INPUT_TYPE.NUMBER) && o.uiVisible && (
                        <div className={`column p-h-l mb-xl web-width-50 padding-bottom-mobile ${o.columnCode}`}
                            key={o.columnCode}>
                            <DKInput
                                ref={ERF.ADD_EMPLOYEE[o.columnCode]}
                                title={`${i+1}. ${o.name}`}
                                placeholder={o.name}
                                value={formValues[o.columnCode]}
                                options={o.options}
                                type={o.type}
                                labelClassName=" text-align-left "
                                onChange={(v) => {
                                    onInputChange(v, o, i+1);
                                }}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                required={getRequiredFields(o)}
                                readOnly={o.readOnly || !PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT])}
                                canValidate={o.hasError}
                                validator={(v) => {
                                    return !o.hasError;
                                }}
                                errorMessage={o.errMsg}
                                tooltip={{
                                    content: o.tooltipText,
                                    className: "warning-tooltip-prop",
                                }}
                            />
                        </div>
                        
                    )}
                    {o.type === INPUT_TYPE.DROPDOWN && o.uiVisible && (
                        <div className={`column p-h-l mb-xl web-width-50 padding-bottom-mobile ${o.columnCode}`}
                            key={o.columnCode}>
                            <DKInput
                                ref={ERF.ADD_EMPLOYEE[o.columnCode]}
                                title={o.name}
                                placeholder={o.name}
                                value={formValues[o.columnCode]}
                                formatter={(o) => {
                                    /** How to render a selected option in case of object **/
                                    return o.name;
                                }}
                                type={o.type}
                                labelClassName=" text-align-left "
                                onChange={(v) => {
                                    onInputChange(v, o, i+1);
                                }}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                required={getRequiredFields(o)}
                                readOnly={o?.readOnly || !PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT])}
                                dropdownConfig={{
                                    className: "",
                                    style: {},
                                    allowSearch: o.options && o.options.length > 6 ? true : false,
                                    searchableKey: "name",
                                    data: o.options,
                                    renderer: (index, obj) => {
                                        /** How to render value in Dropdown in case of object **/
                                        return <DKLabel text={`${obj.name}`} />;
                                    },
                                    onSelect: (index, obj) => {
                                        // onValueChange(obj, "Quarter");
                                    },
                                }}
                                canValidate={o.hasError}
                                validator={(v) => {
                                    return !o.hasError;
                                }}
                                errorMessage={o.errMsg}
                            />
                        </div>
                    )}
                </>
            )
        })
    }

    const getOptionalductionSection = () => {
        return (
            <>
                <div className="mt-xl parent-width bg-white border-radius-s card-shadow" style={{
                    pointerEvents: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "":"none",
                    opacity: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "1":"0.9"
                    }}>
                    <DKExpandableWrapper
                        title="Optional Deductions"
                        className="collapsable"
                        expanded={expandedState}
                        headerStyle={{ padding: "20px" }}
                    >
                        <DKLine className="bg-line-2" />
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                            }}
                            className=" parent-width mb-s pb-m pt-s"
                        >
                            {optionalDeductionFields && getFormFields(optionalDeductionFields.filter((f) => f.uiVisible))}
                        </div>
                    </DKExpandableWrapper>
                </div>
            </>
        )
    }

    const getMedicalExpensesSection = () => {
        return (
            <>
                <div className="mt-xl parent-width bg-white border-radius-s card-shadow" style={{
                    pointerEvents: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "":"none",
                    opacity: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "1":"0.9"
                    }}>
                    <DKExpandableWrapper
                        title="Medical Expenses for:"
                        className="collapsable"
                        expanded={expandedState}
                        headerStyle={{ padding: "20px" }}
                    >
                        <DKLine className="bg-line-2" />
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                            }}
                            className=" parent-width mb-s pb-m pt-s"
                        >
                            {medicalExpensesFields && getFormFields(medicalExpensesFields)}
                        </div>
                    </DKExpandableWrapper>
                </div>
            </>
        )
    }

    const getPreviousEmployeeSection = () => {
        return (
            <>
                <div className="mt-xl parent-width bg-white border-radius-s card-shadow" style={{
                    pointerEvents: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "":"none",
                    opacity: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "1":"0.9"
                    }}>
                    <DKExpandableWrapper
                        title="Previous Employer"
                        className="collapsable"
                        expanded={expandedState}
                        headerStyle={{ padding: "20px" }}
                    >
                        <DKLine className="bg-line-2" />
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                            }}
                            className=" parent-width mb-s pb-m pt-s"
                        >
                            {previousEmployerFields && getPreviousSectionFormFields(previousEmployerFields)}
                        </div>
                    </DKExpandableWrapper>
                </div>
            </>
        )

    }

    const getEmployeeFieldSection = () => {
        return (
            <>
                <div className="parent-width bg-white border-radius-s card-shadow">
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                        }}
                        className=" parent-width mb-s pt-s"
                    >
                        {employeeFields && getFormFields(employeeFields)}
                    </div>

                </div>
            </>
        )
    }

    const getHeader = () => {
        return (
            <div className="parent-width d-flex justify-content-between mb-l">
                <DKLabel
                    text="User Tax Details"
                    className=" fs-r text-align-left fw-m fs-l"
                />
                <div className="d-flex">
                    <DKButton
                        title="Cancel"
                        className="border-radius-m bg-gray1 border-m mr-m"
                        onClick={() => {
                            navigateTo()
                        }}
                    />
                    {PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) && <DKButton
                        title="Save"
                        className="bg-app text-white"
                        onClick={() => {
                            saveTaxDetails()
                        }}
                    />}
                </div>
            </div>
        )
    }

    return (
        <>
            <div className="column parent-width">
                {getHeader()}
                {getEmployeeFieldSection()}
                {getPreviousEmployeeSection()}
                {getOptionalductionSection()}
                {getMedicalExpensesSection()}
            </div>
        </>
    )

}

export default UserTaxDetails;